import type { CinematicMoment } from "@/lib/cinematic/cinematicMomentsEngine";

/**
 * Scripted cinematic beats for WorldCupShowcaseMode.
 * Each beat reuses the CinematicMoment shape so we can plug straight
 * into the existing CinematicMomentCard renderer + PriorityVisualQueue.
 * No DB writes, no realtime — pure curated WOW timeline.
 */
export type ShowcaseBeat = Omit<CinematicMoment, "id" | "createdAt"> & {
  /** dwell in ms before advancing */
  dwellMs: number;
};

export const SHOWCASE_SCRIPT: ShowcaseBeat[] = [
  {
    kind: "community_shockwave",
    emoji: "🌎",
    headlineKey: "sc_beat_world_h",
    subKey: "sc_beat_world_s",
    intensity: 0.9,
    accent: "rose",
    dwellMs: 6500,
  },
  {
    kind: "nation_dominance",
    emoji: "🔥",
    headlineKey: "sc_beat_mex_h",
    subKey: "sc_beat_mex_s",
    tokens: { nation: "México", pct: 58 },
    intensity: 0.85,
    accent: "amber",
    dwellMs: 6500,
  },
  {
    kind: "hype_spike",
    emoji: "💥",
    headlineKey: "sc_beat_shock_h",
    subKey: "sc_beat_shock_s",
    intensity: 0.95,
    accent: "rose",
    dwellMs: 6000,
  },
  {
    kind: "leaderboard_takeover",
    emoji: "🏆",
    headlineKey: "sc_beat_bra_h",
    subKey: "sc_beat_bra_s",
    tokens: { nation: "Brasil" },
    intensity: 0.9,
    accent: "cyan",
    dwellMs: 6500,
  },
  {
    kind: "last_minute_drama",
    emoji: "⚠️",
    headlineKey: "sc_beat_pressure_h",
    subKey: "sc_beat_pressure_s",
    intensity: 1,
    accent: "emerald",
    dwellMs: 7000,
  },
  {
    kind: "prediction_explosion",
    emoji: "🎯",
    headlineKey: "sc_beat_predict_h",
    subKey: "sc_beat_predict_s",
    tokens: { n: "8,400" },
    intensity: 0.8,
    accent: "violet",
    dwellMs: 6000,
  },
  {
    kind: "poll_consensus",
    emoji: "👀",
    headlineKey: "sc_beat_poll_h",
    subKey: "sc_beat_poll_s",
    tokens: { pct: 82 },
    intensity: 0.75,
    accent: "violet",
    dwellMs: 5500,
  },
  {
    kind: "rivalry_surge",
    emoji: "⚔️",
    headlineKey: "sc_beat_rivalry_h",
    subKey: "sc_beat_rivalry_s",
    intensity: 0.9,
    accent: "amber",
    dwellMs: 6000,
  },
];
